import { request } from './utils';

// DPP fanned this one call out to up to three P4 report endpoints based on
// `selectedRecords`. That dispatch now lives here.
export default class ReportService {
    static async dailyProcessingReport(fromDate, toDate, selectedRecords, aggregate = false) {
        const records = selectedRecords || [];
        const payload = { fromDate, toDate, aggregate };
        let response;

        if (records.includes('refunds')) {
            response = await request('/api/reports/refunds', { method: 'POST', data: payload });
        }
        if (records.includes('payments')) {
            response = await request('/api/reports/payments', { method: 'POST', data: payload });
        }
        if (records.includes('fundingRequests')) {
            response = await request('/api/reports/funding_requests', { method: 'POST', data: payload });
        }

        return response;
    }
}
